import { StreamingPlayerError } from '@heardis/stream-contracts';
import { useAuthContext } from '../../contexts/AuthContext';
import { useConfigContext } from '../../contexts/ConfigContext';
import useConfig from '../../hooks/useConfig';
import Head from '../Head/Head';
import LoadingScreen from '../PageLayout/LoadingScreen/LoadingScreen';
import LoginScreen from '../PageLayout/LoginScreen/LoginScreen';
import ThreeRowsPageLayout from '../PageLayout/Templates/ThreeRowsPageLayout';
import StreamingPlayer from './StreamingPlayer';

interface PageViewProps {
  /**
   * @TOASK It expects the defaultProps to be set like "PageView.defaultProps = {}"
   * Is it something we want to leave enabled and do it like this or can we just turn it off?
   * */
  forceEnabled?: boolean;
}

function PageView({ forceEnabled = false }: PageViewProps): JSX.Element {
  const { ui, type, private: authEnabled } = useConfigContext();
  const { user } = useAuthContext();
  const { configIsLoading, errorMessage } = useConfig();
  const showLogin = authEnabled && !user;

  if (configIsLoading) return <LoadingScreen message="Loading config..." />;
  if (errorMessage) return <LoadingScreen message={`Error loading config: ${StreamingPlayerError.FAILED_TO_LOAD_CONFIG}`} />;
  if (!ui.page?.enabled && !forceEnabled) return <LoadingScreen message={`View is not supported: ${StreamingPlayerError.VIEW_NOT_ENABLED}`} />;

  return (
    showLogin ? (
      <LoginScreen page={ui.page} />
    ) : (
      <StreamingPlayer type={type} autoplay={ui.page.features.autoplay}>
        <Head />
        <ThreeRowsPageLayout page={ui.page} />
      </StreamingPlayer>
    )
  );
}

export default PageView;
